import React from "react";
import AText from "./subcomponents/about/AText";
import AImg from "./subcomponents/about/AImg";

import photo from "../assets/img/img2.jpg";

const About = () => {
  return (
    <section
      id="about"
      className="py-12 p-8 flex flex-col lg:flex-row justify-center items-center gap-8"
    >
      <AImg image={photo} alt="Daniel Kowalski Photo" />
      <AText
        title="About Me"
        header="From Intership in Kyndryl to Front-End Developer"
        text={`Software developer with commercial experience in building modern web applications using React.js and Next.js. Currently expanding into full-stack and backend development to build scalable, secure, and containerized architectures using docker on personal homeserver.`}
      />
    </section>
  );
};

export default About;
